import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import DynamicPresentation from '../dynamic/DynamicPresentation'
import LabelValue from '../../packages/kiti/components/presentation/LabelValue'
import { path, filter } from 'ramda'

const FieldValuesPresenter = ({ fieldValues, hideConfidential }) => {
  if (!fieldValues?.length) return false
  const cleanFieldValues = hideConfidential
    ? filter(item => !path(['field', 'configuration', 'confidential'], item), fieldValues)
    : fieldValues
  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      {cleanFieldValues.map(fieldValue => (
        <Col width="50%" key={fieldValue.id}>
          <LabelValue
            label={fieldValue.field?.name}
            children={
              <DynamicPresentation
                bold
                value={fieldValue.value}
                type={fieldValue.field?.type}
                options={fieldValue.field?.options}
              />
            }
          />
        </Col>
      ))}
    </Grid>
  )
}

export default FieldValuesPresenter
